/** @format */
import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { SessionStorageService } from 'sis-common';
import { StudentCourseUnitInfoModalService } from '../../../common/service/student-course-unit-info-modal.service';
import { StudyData, UpcomingStudiesService } from './upcoming-studies.service';

const COLLAPSED_KEY = 'student.frontpage.upcomingStudies.collapsed';

@Component({
    selector: 'app-upcoming-studies',
    templateUrl: './upcoming-studies.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UpcomingStudiesComponent {
    private readonly sessionStorageService = inject(SessionStorageService);
    private readonly upcomingStudiesService = inject(UpcomingStudiesService);
    private readonly studentCourseUnitInfoModalService = inject(StudentCourseUnitInfoModalService);

    readonly upcomingStudies$: Observable<StudyData[]> = this.upcomingStudiesService.getUpcomingStudies().pipe(
        catchError(() => {
            this.searchFailed.set(true);
            return of([]);
        }),
    );

    readonly initiallyCollapsed = this.sessionStorageService.getValueOrDefault(COLLAPSED_KEY, true);

    readonly searchFailed = signal(false);

    openCourseUnitInfoModal(study: StudyData): void {
        this.studentCourseUnitInfoModalService.openCourseUnitModalForEnrolment(
            // opening the dialog will probably crash, if the course unit ID is not provided
            study.courseUnit?.id,
            study.courseUnitRealisation,
            study.enrolment,
        );
    }

    isCurCancelled(data: StudyData): boolean {
        return data.courseUnitRealisation?.flowState === 'CANCELLED' || data.courseUnitRealisation?.flowState === 'ARCHIVED';
    }

    onCollapsedChange(collapsed: boolean) {
        this.sessionStorageService.setValue(COLLAPSED_KEY, collapsed);
    }
}
